<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="template-padding" v-else-if="loaded" > 
        <div class="row" >
            <div class="col-12" >
                <b-input-group>
                    
                    <b-form-input v-model="filter" placeholder="Search events" class="search-input atlass-input-borderless" v-on:keyup.enter="searchInDB()" />
                    <font-awesome-icon icon="times-circle" @click="resetSearch()" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" style="margin-right:80px" >Clear</font-awesome-icon>
                   
                    
                    <font-awesome-icon @click="searchInDB()" icon="search" class="ml-4 cursor-pointer" style="font-size:1.1em; margin-top:9px; opacity:.75;"  :id="`tooltip--searchindatabase-button`"  > Search in DB </font-awesome-icon>
                    <b-tooltip :target="`tooltip--searchindatabase-button`" placement="left" triggers="hover" custom-class="tooltip-auto"   > Search in database <span v-if="!filter" > ( type something first ) </span> </b-tooltip>
                    
                    <a @click="get_new_data" class="ml-4" :id="`tooltip--getlatestleads-button`" > <font-awesome-icon icon="sync" style="font-size:1.1em; margin-top:9px; opacity:.75;" > Refresh </font-awesome-icon> </a>
                    <b-tooltip :target="`tooltip--getlatestleads-button`" placement="bottom" triggers="hover" custom-class="tooltip-auto"   > Refresh data ( load latest leads ) </b-tooltip>
                                        
                </b-input-group>
            </div>
        </div>
        
        
        <vue-good-table
            class=""
            :columns="columns"
            :rows="rows"
            styleClass="vgt-table atlass-datatable"
            :search-options="{ enabled: true, externalQuery: filter }"
            :pagination-options="paginationOptions"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
            @on-page-change="onPageChange"
             >
            
            <template slot="table-row" slot-scope="props">
                
                <span v-if="props.column.field == 'actions'">
                    
                  <a class="mr-3" @click="openLead(props.row.leadID)"> <font-awesome-icon icon="user" /> </a>
                  <a class="mr-2" @click="openEvent(props.row.id)"> <font-awesome-icon icon="angle-double-right" /> </a>
                  <a class="mr-2" @click="deleteRow(props.row.id)"> <font-awesome-icon icon="trash-alt" /> </a>
                </span>
                
                <span v-else-if="props.column.field == 'referralURL' " :id="`tooltip--${props.column.field}--${props.row.id}`" > 
                    {{ returnShortString( props.row.referralURL, 'referralURL' ) }} 

                    <b-tooltip :target="`tooltip--${props.column.field}--${props.row.id}`" placement="bottom" triggers="hover"  >
                        <span v-if="props.column.field == 'previousURL' "  > 
                            {{ props.row.previousURL }} 
                        </span>
                        <span v-else-if="props.column.field == 'referralURL' "  >
                            {{ props.row.referralURL }}
                        </span> 
                    </b-tooltip>
    
                </span>

                <span v-else  >
                  {{props.formattedRow[props.column.field]}}
                </span>
                
            </template>
            
        </vue-good-table>
          
        
        <modal :modalData="modalData" :modalState="modalState" :modalComponent="modalComponent" ></modal>
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
    
import modal from '@/components/modal.vue'    
import helper from '@/helpers/helpers.js';
    
export default{
    name: "OrgEvents",
    components:{
        modal
    },
    props: {
        ID: { 
            type: [Number, String],
        },
    },
    data () {
        return {
            filter: '',
            columns: [
                {
                    label: 'LEAD',
                    field: 'leadID',
                    //field: this.renderEventName
                },
                {
                    label: 'NAME',
                    //field: 'name',
                    field: this.renderEventName
                },
                {
                    label: 'IP',
                    field: 'IP',
                    //field: this.renderTag
                },
                {
                    label: 'TAGS',
                    field: 'tag',
                    formatFn: this.renderTag,
                },
                {
                    label: 'DETAILS',
                    field: 'referralURL',
                    //field: this.renderDetails
                },
                {
                    label: 'DATETIME',
                    field: 'datetime',
                    formatFn: this.renderDate,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
                {
                    label: 'ACTION',
                    field: 'actions',
                    sortable: false,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
            ],
            paginationOptions:{ 
                enabled: true,
                perPage: 20,
                perPageDropdown: [50, 100],
                dropdownAllowAll: true,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Conversions per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
                perPageDropdownEnabled: false,
            },
            storedRows: [],
            rows: [],
            loaded: false,
            modalData: null,
            modalState: false,
            modalComponent: null,
            testCollection: [],
            loggedOrgID: null
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        
        console.log( this.ID )
        this.loggedOrgID = this.ID
        this.get_data();
        
    },
    computed: {
    },
    methods: {
        
        /*GET DATA */
        
        get_data( startAtDoc = null, endBefore = null, loadSpinner = true ){
            
            if( loadSpinner ){
                this.dataLoaded = false
            }
            
            let orgID = this.ID
            
            const db = this.$firebase.firestore();
            
            //var ref = db.collection('organizations/'+orgID+'/leads').where('email', '>', '' )
            //var ref = db.collection('organizations/'+orgID+'/leads').where('filter.email_salt', '==', true ).orderBy('filter.datetime', 'desc').limit(50)
            
            if( endBefore == null && startAtDoc == null ){
                var ref = db.collection('organizations/'+orgID+'/events').orderBy('datetime', 'desc').limit(40)
            }else if( startAtDoc == null && endBefore != null ){
                var ref = db.collection('organizations/'+orgID+'/events').orderBy('datetime', 'desc').endBefore( endBefore )
            }else if( startAtDoc != null && endBefore == null ){
                var ref = db.collection('organizations/'+orgID+'/events').orderBy('datetime', 'desc').startAfter( startAtDoc ).limit(20)
            }
            
            return ref.get()
                .then((snapshot) => {
                    let results = this.rows;
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                /*
                                var subcollection = this.getSubcollectionDocs(doc.id);
                                return subcollection.then((docs) => {              
                                    item.tags_subcollection = docs;
                                    results.push(item);     
                                    //console.log( item )
                                    
                                    this.rows = results
                                    
                                    
                                    return results;      
                                });
                                */
                            
                                results.push(item);     
                                //console.log( item )

                                results.sort((a, b) => b.datetime - a.datetime);
                            
                                this.rows = results
                                this.storedRows = results

                                return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        this.dataLoaded = true;
                        this.paginationOptions.setCurrentPage = this.currentPage
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        
        get_new_data(){
            
            let last = this.storedRows[0]
            //console.log(last)
            this.currentPage = 1
            this.get_data( null, last.datetime )
            
        },
        
        load_more( ){
            
            console.log( "load more documents" )
            let startAt = this.rows[ this.rows.length - 1 ]
            console.log( "start with: "+ startAt.email )
            this.get_data( startAt.datetime, null )
            
        },
        
        onPageChange( params ){
            
            //console.log( params )
            
            this.currentPage = params.currentPage;
            
            if( params.currentPage >= params.total ){
                //console.log( "load more documents" )
                let startAt = this.rows[ this.rows.length - 1 ]
                //console.log( "start with: "+ startAt.email )
                this.get_data( startAt.datetime, null, false )
            }

        },
        
        resetSearch(){
            this.filter = ''
            if( this.rows != this.storedRows && this.storedRows.length > 0 ){
               this.rows = this.storedRows
            }
        },
        
        searchInDB(){
            
            var regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
            var regexPhone = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
            
            if( this.filter ){
                
                if( this.filter.startsWith( "@" ) || this.filter.startsWith("!") || this.filter.startsWith("$") ){
                    console.log("search by tag: "+this.filter )
                    this.searchFirestore( "tag", this.filter )
                }else{
                    console.log("search by IP: "+this.filter )
                    this.searchFirestore( "IP", this.filter )
                }
            }
                
        },
        
        searchFirestore( field, value ){
            
            this.dataLoaded = false

            this.storedRows = this.rows
            //console.log( this.storedRows )
            
            let orgID = this.ID
            const db = this.$firebase.firestore();

            var ref = db.collection('organizations/'+orgID+'/events').where(field, '>=', value).where(field, '<=', value+ '\uf8ff')            

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                            
                                results.push(item);     
                                console.log( item )

                                results.sort((a, b) => b.datetime - a.datetime);
                            
                                this.rows = results


                                return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        this.dataLoaded = true;
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        
        /*GET DATA */
        
        renderEventName(a){
            //console.log(a)
            
            let message = "..."
            
            if( a.type == "CLICK" ){
                let city = 'unknown'
                let country = 'unknown'
                if( a.location && a.location.city ){ 
                    city = a.location.city 
                    country =  a.location.country
                }
                let location = city + ", " + country

                message = "Click from " + location 
            }
                
            
            return message
        },
        renderDetails(a){
            //console.log(a)
            
            let message = ""

            
            return message
        },
        renderTag(a){
            
            let tags = []
            a.tags.forEach((tag)=>{
                tags.push(tag)
            })
            
            return tags.join(',')
                
        },
        returnShortString(link, type){
            let limit = 65
            if( link != null ){
                if( link.length > limit ){
                    return link.substring(0,limit) + "..."
                }else{
                    return link
                }
            }else{
                return ''
            }
                
            
        },
    
        renderDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },

        fModalOpen( data ){
            this.modalState = true;
            this.modalData = data
        },
        
        openEvent(id){
            this.modalComponent = "event"
            this.fModalOpen( id );
            
        },
        
        openLead(id){
            this.modalComponent = "lead"
            this.fModalOpen( id );
        },
        
        deleteRow(id){
            //this.fModalOpen( params.row.id );
            this.PreventDelete(id)
        },
        
        PreventDelete( ID ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.delete(ID);
                    
                }
            })
            
        },        
        delete: function(ID){
            
            this.loaded = false

            let ref = firebase.firestore().collection('organizations/'+this.ID+'/events').doc( ID )
            return ref.delete()
                .then(function(){
                
                     this.$toast.success({
                        title: 'Success',
                        message: 'Event deleted'
                    })

                }.bind(this))
                .then(function(){
                
                    this.rows = this.rows.filter(function( obj ) {
                        return obj.id !== ID;
                    });
                
                    this.loaded = true
                    this.modalData = null
                    this.modalState = false
                
                }.bind(this))
                .catch(function(error){
                
                    //console.error("Error updating document: ", error);
                    this.$toast.error({
                        title: 'Error',
                        message: "Something went wrong: "+error
                    })
                
                    this.loaded = true
                
                }.bind(this))
        }
    },
    computed:{
    },
}
</script>

<style >
    
</style>


// WEBPACK FOOTER //
// src/templates/admin/OrgEvents.vue